import { decamelizeKeys } from 'humps'

import { get } from './requests'

export const getAtm = (key, payload) =>
  get(['checking-account', 'atms'], { key, params: decamelizeKeys(payload) })
